<template>
  <ContentSection>
    <div>
      <Container>
        <!-- HEADER -->
        <h2 class="mb-9 typo-label-md sm:typo-label-lg" v-html="data.heading" />
      </Container>

      <!-- ARTICLES -->
      <ul
        v-if="data.entries.length"
        ref="sliderContainer"
        v-drag-scroll
        v-animate-children-in-from-left
        class="flex select-none gap-5 pr-11 lg:pr-[12.5rem] md:pr-[5.25rem]"
      >
        <li
          v-for="(article, index) in data.entries"
          :key="article.id"
          class="flex flex-col"
        >
          <CardBlogArticle
            :is-first="index === 0"
            :data="article"
            class="
              max-w-[calc(100vw-(2*1.875rem+1rem))] translate-x-container cursor-pointer
              lg:translate-x-container-desktop
              md:translate-x-container-lg
            "
            :class="index === 0 ? 'w-[40rem]' : 'w-96'"
          />
        </li>
      </ul>

      <Container v-animate-in-from-bottom class="mt-4">
        <!-- NO RESULTS -->
        <NoEntriesFound v-if="!data.entries.length" />

        <!-- PAGINATION -->
        <PaginationSlider
          :amount-pages="sliderContainer?.amountPages?.value || 1"
          :active-index="sliderContainer?.activeIndex?.value || 0"
          @scroll-to-item="sliderContainer?.scrollToItem ? sliderContainer?.scrollToItem($event) : null"
        />
      </Container>
    </div>
  </ContentSection>
</template>

<script setup lang="ts">
import type { DragElement } from '~/plugins/dragScroll'

defineProps({
  data: {
    type: Object,
    required: true,
  },
})

const sliderContainer = ref<DragElement | null>(null)
</script>
